<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Prediksi KGB
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Prediksi KGB</h5>
    </div>
    <div class="content-block">
      <dx-popup
        :visible="popUpPrediksiVisible"
        title="Konfirmasi Prediksi KGB"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="300"
        :height="150"
      >
        Tetapkan prediksi KGB ini?

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptionsPrediksi"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonOptionsPrediksi"
        />
      </dx-popup>

      <div class="dx-card responsive-paddings">
        <!-- <DatagridRefreshTemplate gridref="gridRef" /> -->

        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="ID"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
        >
          <DxExport :enabled="true" />
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="100" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <DxColumn
            caption="#"
            data-field="created_at"
            data-type="number"
            :cell-template="cellRenderer"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            data-field="pegawai.nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            data-type="string"
          >
          </DxColumn>
          <DxColumn
            data-field="pegawai.nama"
            caption="Pegawai"
            :fixed="true"
            fixed-position="left"
            data-type="string"
          >
          </DxColumn>
          <DxColumn
            data-field="pegawai.tgl_mulai_bekerja"
            caption="Tgl Mulai Bekerja"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allow-filtering="false"
            :fixed="true"
            fixed-position="left"
          />

          <!-- <DxColumn data-field="pegawai_id" caption="Pegawai">
            <DxLookup
              :data-source="pegawaiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn> -->
          <DxColumn
            data-field="pegawai.simpegKgbs[0].tgl"
            caption="KGB Terakhir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allow-filtering="false"
          />
          <!-- dont allow filter -->
          <DxColumn
            data-field="pegawai.simpegKgbs[0].masa_kerja"
            caption="Masa Kerja Terakhir (Tahun)"
            :allow-filtering="false"
            cell-template="template-mk-tahun"
            data-type="number"
          />
          <DxColumn
            data-field="pegawai.simpegKgbs[0].masa_kerja_bulan"
            caption="Masa Kerja Terakhir (Bulan)"
            :allow-filtering="false"
            cell-template="template-mk-bulan"
            data-type="number"
          />

          <template #template-mk-bulan="{ data }">
            {{ data.text }} Bulan
          </template>
          <template #template-mk-tahun="{ data }">
            {{ data.text }} Tahun
          </template>

          <!-- dont allow filter -->

          <DxColumn
            data-field="tgl"
            caption="Prediksi KGB Selanjutnya"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :calculate-filter-expression="calculateFilterExpression"
            :filter-operations="filterOperations"
            css-class="cell-highlighted"
          />
          <DxColumn
            data-field="masa_kerja"
            caption="Prediksi Masa Kerja Selanjutnya (Tahun)"
            css-class="cell-highlighted"
            cell-template="template-mk-tahun"
            data-type="number"
          >
          </DxColumn>
          <DxColumn
            data-field="masa_kerja_bulan"
            caption="Prediksi Masa Kerja Selanjutnya (Bulan)"
            css-class="cell-highlighted"
            cell-template="template-mk-bulan"
            data-type="number"
          >
          </DxColumn>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
            data-type="number"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 170 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import api from "@/api";
import can from "@/haspermission";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import axios from "axios";
import _ from "lodash";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
// import DatagridRefreshTemplate from "./DatagridRefreshTemplate.vue";

const options = [
  "Detail Pegawai",
  "Absensi",
  "Riwayat Gaji",
  "Tetapkan sebagai KGB",
];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/SimpegKgbPrediksis`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      console.log(e);

      if (hasFilterNestedTable(e.params.$filter)) {
        // e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongans");
        if (hasFilterNestedTable(e.params.$filter)) {
          e.params.$filter = convertFilterPegawai(e.params.$filter);
        }
      }
      console.log("beforeSend DS", e);
      e.params.$orderby = "pegawai_id";
    },
  }),
  filter: [["versi", "=", 2]],
  expand: ["pegawai($expand=simpegKgbs($filter=status eq 1))"],
});

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxButton,
    DxPager,
    DxExport,
    DxDropDownButton,
    DxPopup,
    DxToolbarItem,
    DxToolbar,
    DxItem,

    // DatagridRefreshTemplate,
  },
  data() {
    return {
      pegawaiId: null,
      popUpPrediksiVisible: false,
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      confirmButtonOptionsPrediksi: {
        text: "Tetapkan KGB",
        onClick: () => {
          //tambahkan ijazahfile ke array
          this.tetapkanPrediksiKgb();
          this.popUpPrediksiVisible = false;
        },
      },

      cancelButtonOptionsPrediksi: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popUpPrediksiVisible = false;
        },
      },

      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        console.log("calculateFilterExpression filterValue", filterValue);
        console.log(
          "calculateFilterExpression selectedFilterOperation",
          selectedFilterOperation
        );
        console.log("calculateFilterExpression target", target);
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          console.log("calculateFilterExpression", "masuk ==");

          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];
          console.log(filterExpression5);
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        console.log("ONEDITORPREPARING");
        console.log(e);
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },
  mounted() {},
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    cellRenderer(cellElement, cellInfo) {
      cellElement.innerText =
        this.numberingPageNumber * this.numberingPageSize +
        cellInfo.row.rowIndex +
        1;
    },
    can,
    refreshDatagrid(gridRef) {
      //   alert("hello " + this.gridref);
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Prediksi KGB.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    async onItemClick(e) {
      console.log("onItemClick", e);
      console.log("onItemClick", e.itemData);
      this.pegawaiId = e.element.id;

      if (e.itemData === "Tetapkan sebagai KGB") {
        if (this.can("pegawai-update")) this.popUpPrediksiVisible = true;
        else notify("Tidak dapat melakukan aksi ini", "error");
        // this.tetapkanPrediksiKgb(pegawaiId);
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: this.pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list",
          query: { filter: ["pegawai_id", "=", this.pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", this.pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // }); inside this tab
    },

    async tetapkanPrediksiKgb() {
      //set prediksi kgb into the current kgb
      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      console.log("debug", "tetapkanPrediksiKgb data", data);

      await axios
        .post(`${API_BASE_URL}/tetapkan_kgb_prediksi`, data, config) //insert kgb baru berdasarkan data prediksi
        .then(() => {
          this.savedKgb(); //buat kgb prediksi berdasarkan kgb yang baru diinsert
          notify("Penetapan KGB berhasil", "success");
        })
        .catch((error) => {
          console.log(error);
          notify("Penetapan KGB gagal", "error");
        });

      this.refreshDatagrid("gridRef");
    },

    async savedKgb() {
      console.log("debug", "savedKgb");
      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/sinkron_kgb_prediksi`,
        data,
        config
      );

      console.log("savedKgb response", response);
    },
  },
};
</script>
